import { useAuth } from 'contexts/auth';
import InstructorViewAssignmentPage from 'pages/InstructorViewAssignment';

const ViewAssignmentPage = () => {
    const { auth } = useAuth();
    if (auth.role === 'instructor') return <InstructorViewAssignmentPage />;
    return null;
};

export default ViewAssignmentPage;
